<template>
  <!-- <div style="width: 100px;height: 100px"> -->
  <div
    class="MoveTabNavigationContainer"
    :class="{ dragging: isDragging }"
    :style="{
      background: isExpanded
        ? `linear-gradient(180deg, ${'#' + background}f0 0%, ${'#' + background}cc 70%, ${
            '#' + background
          }80 90%, transparent 100%)`
        : 'none',
      transform: `translate(${currentX}px, ${currentY}px)`,
      cursor: isDragging ? 'grabbing' : 'grab',
    }"
  >
    <!-- <van-sticky :offset-top="90"> -->
    <div
      ref="stepsContainer"
      class="steps-container"
      :style="{
        height: showContent ? (options && options.length > 2 ? '216px' : '136px') : '0',
        overflow: 'auto',
        scrollbarWidth: 'none',
        transition: 'height 0.3s ease',
        backgroundColor: `${'#' + background}`,
        backdropFilter: 'blur(20px) saturate(180%)',
        borderRadius: '40px 40px 0 0',
        boxSizing: showContent ? 'border-box' : 'content-box',
        paddingTop: showContent ? '20px' : '0',
        paddingBottom: showContent ? '39px' : '0',
        marginBottom: showContent ? '-39px' : '0',
      }"
    >
      <van-steps
        ref="vanSteps"
        :style="{ backgroundColor: `${'#' + background}` }"
        :active="currentActive"
        direction="vertical"
        size="small"
        @click-step="clickStep"
        :active-color="'#' + activeFontColor"
        :inactive-color="'#' + inactiveFontColor"
        active-icon="stop"
      >
        <van-step
          v-for="(item, index) in options"
          :key="index"
          :style="{
            paddingRight: 0,
            cursor: index > currentActive ? 'not-allowed' : 'pointer',
            opacity: index > currentActive ? 0.5 : 1,
            color: index < currentActive ? `#${finishFontColor}` : '',
          }"
          :class="{ 'step-disabled': index > currentActive }"
        >
          {{ item.title }}
        </van-step>

        <van-step v-if="!options || options.length === 0" title="第一步" />
      </van-steps>
    </div>
    <div
      class="expand-button-Container"
      :class="{ 'container-collapsed': !isExpanded }"
      :style="{ height: isExpanded ? '78px' : `${collapsedContainerHeight}px` }"
      @touchstart="startDrag"
      @touchmove="onDrag"
      @touchend="stopDrag"
    >
      <van-button
        @click="toggleExpanded"
        class="expand-button"
        :class="{ 'button-collapsed': !isExpanded }"
        :style="{
          backgroundColor: `${'#' + background}`,
          width: isExpanded ? '78px' : `${collapsedButtonSize}px`,
          height: isExpanded ? '78px' : `${collapsedButtonSize}px`,
        }"
      >
        <van-icon
          name="arrow-up"
          class="arrow-icon"
          :class="{ 'arrow-rotated': !isExpanded }"
          :color="'#' + arrowColor"
          :size="isExpanded ? '1rem' : collapsedIconSize"
        />
      </van-button>
    </div>
    <!-- </van-sticky> -->
  </div>
</template>

<script>
import { Step, Steps, Icon, Button, Sticky } from 'vant';
export default {
  name: 'MoveTabNavigation',
  components: {
    'van-steps': Steps,
    'van-step': Step,
    'van-icon': Icon,
    'van-button': Button,
    'van-sticky': Sticky,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    options: {
      type: Array,
      default: () => [],
    },
    collapse: {
      type: Boolean,
      default: true,
    },
    move: {
      type: Boolean,
      default: true,
    },
    background: {
      type: String,
      default: '666',
    },
    activeFontColor: {
      type: String,
      default: '07c160',
    },
    inactiveFontColor: {
      type: String,
      default: 'E5EBE7',
    },
    finishFontColor: {
      type: String,
      default: 'fff',
    },
    arrowColor: {
      type: String,
      default: 'fff',
    },
    collapsedScale: {
      type: Number,
      default: 0.5,
    },
  },
  mounted() {
    // 初始化屏幕尺寸
    if (window.visualViewport) {
      this.screenWidth = Math.round(window.visualViewport.width);
      this.screenHeight = Math.round(window.visualViewport.height);
    } else {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth;
      this.screenHeight = window.innerHeight || document.documentElement.clientHeight;
    }

    // 设置初始位置为右侧，但确保可以向左移动
    // 使用 transform 而不是 CSS 的 right 属性
    this.currentX = this.screenWidth - 78 - 10; // 距离右边10px
    this.currentY = 90; // 距离顶部90px
  },
  data() {
    return {
      isExpanded: !this.collapse,
      showContent: !this.collapse,
      currentActive: this.value || 0,
      longPressTimer: null,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      initialX: 0,
      initialY: 0,
      currentX: 0,
      currentY: 0,
      screenWidth: 0,
      screenHeight: 0,
      hasMoved: false,
    };
  },
  computed: {
    collapsedButtonSize() {
      return 78 * this.collapsedScale; // 78px 是完整大小
    },
    collapsedContainerHeight() {
      return this.collapsedButtonSize + 5; // 按钮大小 + 5px margin
    },
    collapsedIconSize() {
      return `${this.collapsedScale}rem`;
    },
    collapsedBackgroundExtend() {
      return this.collapsedButtonSize / 2; // 背景延伸到按钮的一半
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue !== undefined && newValue !== null) {
          this.currentActive = newValue;
          this.$nextTick(() => {
            this.scrollToActiveStep();
          });
        }
      },
      immediate: true,
    },
    currentActive: {
      handler() {
        this.$nextTick(() => {
          this.scrollToActiveStep();
        });
      },
    },
    showContent: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.scrollToActiveStep();
          });
        }
      },
    },
  },
  methods: {
    scrollToActiveStep() {
      if (!this.showContent || !this.$refs.stepsContainer) {
        return;
      }

      this.$nextTick(() => {
        const container = this.$refs.stepsContainer;
        const steps = this.$refs.vanSteps?.$el;
        
        if (!steps) return;

        const stepElements = steps.querySelectorAll('.van-step');
        const activeStep = stepElements[this.currentActive];

        if (!activeStep) return;

        const stepOffsetTop = activeStep.offsetTop;
        const paddingTop = 20;

        container.scrollTo({
          top: stepOffsetTop - paddingTop,
          behavior: 'smooth',
        });
      });
    },
    toggleExpanded() {
      if (this.isExpanded) {
        // 收起：先收起内容，再缩小按钮
        this.showContent = false;
        setTimeout(() => {
          this.isExpanded = false;
        }, 150); // 内容收起动画的一半时间后开始按钮缩放
      } else {
        // 展开：先放大按钮，再展开内容
        this.isExpanded = true;
        // 延迟展开内容，让按钮缩放动画先执行
        setTimeout(() => {
          this.showContent = true;
        }, 150); // 按钮缩放动画的一半时间后开始内容展开
      }
    },
    clickStep(e) {
      // 限制：当前步骤的下一步永远不可点击进入
      // 只允许点击当前步骤及之前的步骤
      if (e > this.currentActive) {
        console.log('不允许跳转到未来步骤:', e, '当前步骤:', this.currentActive);
        return; // 阻止跳转到未来步骤
      }

      this.currentActive = e;
      this.$emit('input', e);
      this.$emit('update:modelValue', e);
      this.$emit('clickStep', e);
      this.$emit('change', e);
      
      this.$nextTick(() => {
        this.scrollToActiveStep();
      });
    },
    handleStepChange(current) {
      //   this.currentActive = current;
      //   const item = this.options?.[current];
      //   const fn = item?.['func'];
      //   let fn = null;
      //   fn = this.reviveFunction(item.func)
      //   if (typeof fn === 'function') {
      //     return fn({  vm: this,index: current, item, });
      //   }
    },
    startDrag(e) {
      if (!this.move) return;
      const touch = e.touches ? e.touches[0] : e;
      this.isDragging = true;
      this.hasMoved = false;
      this.dragStartX = touch.clientX;
      this.dragStartY = touch.clientY;
      this.initialX = this.currentX;
      this.initialY = this.currentY;
    },
    onDrag(e) {
      if (!this.move) return;
      if (!this.isDragging) return;

      const touch = e.touches ? e.touches[0] : e;
      const deltaX = touch.clientX - this.dragStartX;
      const deltaY = touch.clientY - this.dragStartY;

      // 立即开始拖拽，不等待阈值
      if (!this.hasMoved && (Math.abs(deltaX) > 2 || Math.abs(deltaY) > 2)) {
        this.hasMoved = true;
      }

      if (this.hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }

      // 计算新位置
      const newX = this.initialX + deltaX;
      const newY = this.initialY + deltaY;

      // 简化边界检测
      const elementWidth = 78; // 固定宽度
      const elementHeight = this.isExpanded ? 300 : 78; // 根据展开状态调整高度

      const minX = 0;
      const maxX = this.screenWidth - elementWidth;
      const minY = 0;
      const maxY = this.screenHeight - elementHeight;

      // 应用边界限制
      this.currentX = Math.max(minX, Math.min(maxX, newX));
      this.currentY = Math.max(minY, Math.min(maxY, newY));
    },
    stopDrag() {
      if (!this.move) return;
      this.isDragging = false;
      // 立即重置移动标记
      this.hasMoved = false;
    },
    // 程序化设置当前步骤
    setCurrentStep(step, force = false) {
      if (step >= 0 && step < (this.options?.length || 1)) {
        // 如果不是强制设置，且试图跳转到未来步骤，则阻止
        if (!force && step > this.currentActive) {
          console.log('程序化调用也不允许跳转到未来步骤:', step, '当前步骤:', this.currentActive);
          return;
        }

        this.currentActive = step;
        this.$emit('input', step);
        this.$emit('update:modelValue', step);
        this.$emit('clickStep', step);
        
        this.$nextTick(() => {
          this.scrollToActiveStep();
        });
      }
    },
    // 下一步（程序化调用，不受点击限制影响）
    nextStep() {
      const maxStep = (this.options?.length || 1) - 1;
      if (this.currentActive < maxStep) {
        this.setCurrentStep(this.currentActive + 1, true); // 强制允许跳转
      }
    },
    // 上一步
    prevStep() {
      if (this.currentActive > 0) {
        this.setCurrentStep(this.currentActive - 1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.MoveTabNavigationContainer {
  width: 78px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  border-radius: 40px 40px 0 0;
  box-sizing: border-box;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
  transition: filter 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover:not(.dragging) {
    filter: drop-shadow(0 6px 20px rgba(0, 0, 0, 0.25));
  }

  // 步骤容器样式
  .steps-container {
    position: relative;
    z-index: 1;

    // 确保未展开时完全隐藏
    &[style*='height: 0'] {
      padding: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
    }
  }

  // 步骤容器颜色优化
  .van-steps {
    padding: 0 16px;

    :deep(.van-step) {
      .van-step__title {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.4;
        margin-left: 8px;
        color: rgba(255, 255, 255, 0.9);
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      }

      .van-step__circle-container {
        .van-step__circle {
          width: 20px;
          height: 20px;
          border-width: 2px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
        }

        .van-step__icon {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.9);
        }
      }

      .van-step__line {
        margin-left: 10px;
        width: 2px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.3) 0%,
          rgba(255, 255, 255, 0.1) 100%
        );
      }

      // 激活状态颜色
      &.van-step--active {
        .van-step__title {
          color: #fff;
          font-weight: 600;
        }

        .van-step__circle {
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.3) 0%,
            rgba(255, 255, 255, 0.1) 100%
          );
          border-color: rgba(255, 255, 255, 0.8);
          box-shadow: 0 0 12px rgba(255, 255, 255, 0.3);
        }
      }

      // 完成状态颜色
      &.van-step--finish {
        .van-step__title {
          color: rgba(255, 255, 255, 0.7);
        }

        .van-step__circle {
          background: linear-gradient(135deg, rgba(7, 193, 96, 0.8) 0%, rgba(7, 193, 96, 0.6) 100%);
          border-color: rgba(7, 193, 96, 0.9);
        }
      }

      // 禁用状态样式（未来步骤）
      &.step-disabled {
        pointer-events: none;

        .van-step__title {
          color: rgba(255, 255, 255, 0.3) !important;
          cursor: not-allowed;
        }

        .van-step__circle {
          background: rgba(255, 255, 255, 0.05) !important;
          border-color: rgba(255, 255, 255, 0.2) !important;
          cursor: not-allowed;
        }

        .van-step__icon {
          color: rgba(255, 255, 255, 0.3) !important;
        }

        .van-step__line {
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0.05) 100%
          ) !important;
        }
      }
    }
  }

  .expand-button-Container {
    display: flex;
    justify-content: center;
    height: 78px;
    user-select: none;
    position: relative;
    z-index: 2;
    transition: height 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

    // 容器高度现在通过内联样式动态控制

    .expand-button {
      width: 78px;
      height: 78px;
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      user-select: none;
      position: relative;
      overflow: hidden;
      transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      backdrop-filter: blur(20px) saturate(180%);

      // 未展开时的小尺寸状态
      &.button-collapsed {
        border-width: 1px;
        margin-bottom: 5px; // 调整间距

        &::before {
          top: 1px;
          left: 1px;
          right: 1px;
        }
      }

      // 渐变背景叠加
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.15) 0%,
        rgba(255, 255, 255, 0.05) 50%,
        rgba(0, 0, 0, 0.05) 100%
      );

      // 多层阴影效果
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2), inset 0 -1px 0 rgba(0, 0, 0, 0.1),
        0 2px 8px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(255, 255, 255, 0.05);

      // 光泽效果
      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        right: 2px;
        height: 50%;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.2) 0%,
          rgba(255, 255, 255, 0.05) 70%,
          transparent 100%
        );
        border-radius: 50% 50% 80% 80%;
        pointer-events: none;
      }

      &:hover {
        transform: scale(1.05);
        border-color: rgba(255, 255, 255, 0.4);
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.2) 0%,
          rgba(255, 255, 255, 0.08) 50%,
          rgba(0, 0, 0, 0.03) 100%
        );
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3), inset 0 -1px 0 rgba(0, 0, 0, 0.1),
          0 4px 16px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.1),
          0 0 20px rgba(255, 255, 255, 0.1);
      }

      &:active {
        transform: scale(0.98);
        transition-duration: 0.1s;
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.1) 0%,
          rgba(255, 255, 255, 0.03) 50%,
          rgba(0, 0, 0, 0.08) 100%
        );
      }

      // 图标颜色和效果
      .van-icon {
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
        color: rgba(255, 255, 255, 0.9);

        &.arrow-icon {
          transform: rotate(0deg);
          transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          will-change: transform;

          &.arrow-rotated {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  // 响应式颜色调整
  @media (max-width: 480px) {
    width: 68px;
    right: 8px;

    .expand-button-Container {
      height: 68px;

      .expand-button {
        width: 68px;
        height: 68px;
        border-width: 1.5px;
      }
    }
  }

  // 深色模式颜色适配
  @media (prefers-color-scheme: dark) {
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3));

    &:hover {
      filter: drop-shadow(0 6px 20px rgba(0, 0, 0, 0.4));
    }

    .expand-button-Container .expand-button {
      border-color: rgba(255, 255, 255, 0.15);
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.08) 0%,
        rgba(255, 255, 255, 0.02) 50%,
        rgba(0, 0, 0, 0.1) 100%
      );

      &:hover {
        border-color: rgba(255, 255, 255, 0.25);
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.12) 0%,
          rgba(255, 255, 255, 0.04) 50%,
          rgba(0, 0, 0, 0.08) 100%
        );
      }
    }
  }
}

// 全局优化
.MoveTabNavigationContainer * {
  -webkit-tap-highlight-color: transparent;
}

// 自定义颜色变量（可根据主题动态调整）
.MoveTabNavigationContainer {
  --primary-color: #07c160;
  --primary-light: rgba(7, 193, 96, 0.1);
  --text-primary: rgba(255, 255, 255, 0.9);
  --text-secondary: rgba(255, 255, 255, 0.7);
  --border-color: rgba(255, 255, 255, 0.25);
  --shadow-color: rgba(0, 0, 0, 0.15);
}
</style>
